import React from 'react'
import {Lang} from 'yougile-lang'
import {canShowTask} from '@extensions/mirrored-tasks/permissions'
import {Task} from '@extensions/task'
import {TaskCardProps} from './task-card'

export const Locations = (props: TaskCardProps) => {
  return (
    <div className="m-4 max-w-240">
      <div className="mb-4 font-semibold text-on-color">
        {Lang.msg.subtask.location}
      </div>
      <LocationsContent {...props} />
    </div>
  )
}

const LocationsContent = (props: TaskCardProps) => {
  if (!canShowTask(props.task)) {
    return <Line title={Lang.msg.subtask.noPermissionForLocation} />
  }

  const locations = Task.getLocations(props.task.id)

  if (locations?.parentTasks?.length) {
    return (
      <>
        {locations.parentTasks.map(parent => (
          <Line key={parent.id} title={Lang.msg.common.subtaskOf}>
            {parent.title}
          </Line>
        ))}
      </>
    )
  } else if (
    locations &&
    !locations?.project?.deleted &&
    locations.project &&
    locations.column &&
    locations.board
  ) {
    return (
      <>
        <Line title={Lang.msg.common.project}>{locations.project.title}</Line>
        <Line title={Lang.msg.common.board}>{locations.board.title}</Line>
        <Line title={Lang.msg.common.column}>{locations.column.title}</Line>
      </>
    )
  } else if (!locations?.column) {
    return <Line title={Lang.msg.subtask.withoutBoard} />
  } else {
    return <Line title={Lang.msg.subtask.noPermissionForLocation} />
  }
}

const Line = ({
  title,
  children
}: {
  title: string
  children?: React.ReactNode
}) => (
  <div className="mb-4 text-obscure-constant-old text-no-wrap">
    <span>{title}</span>
    {children && (
      <>
        : <span className="font-semibold">{children}</span>
      </>
    )}
  </div>
)
